import React from 'react';

export default function Page({ page, details }) {
    const { title } = details;
    return (
        <div>
            {page}
        </div>
    )
}